module.exports = __webpack_public_path__ + "img/chart-area-white.2786cb62.svg";